import React from 'react';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import Switch, { SwitchClassKey, SwitchProps } from '@material-ui/core/Switch';

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface Props extends SwitchProps {
  classes: Styles;
}

const LargeSwitch = withStyles(({ spacing, palette, transitions }: Theme) =>
  createStyles({
    root: {
      width: 64,
      minWidth: 64,
      height: 32,
      padding: 0,
      margin: spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(32px)',
        color: palette.common.white,
        '& + $track': {
          backgroundColor: palette.primary.main,
          opacity: 1,
          border: `1px solid ${palette.primary.main}`,
        },
      },
      '&$focusVisible $thumb': {
        color: palette.primary.main,
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 30,
      height: 30,
    },
    track: {
      borderRadius: 32 / 2,
      border: `1px solid ${palette.grey[200]}`,
      backgroundColor: palette.grey[200],
      opacity: 1,
      transition: transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  })
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

interface FsLargeSwitchProps {
  name?: string;
  onChange?: () => void;
  checked?: boolean;
}

const FsLargeSwitch: React.FC<FsLargeSwitchProps> = ({
  name,
  onChange,
  checked,
}) => {
  return <LargeSwitch checked={checked} onChange={onChange} name={name} />;
};

export default FsLargeSwitch;
